import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { BACK_OPTION_LABELS } from "../lib/api";
import { Trash2, Minus, Plus } from "lucide-react";

export default function Cart() {
  const { items, removeItem, updateQty, subtotal } = useCart();
  const navigate = useNavigate();
  const contribution = (subtotal * 0.15).toFixed(2);

  if (items.length === 0)
    return (
      <div className="max-w-3xl mx-auto px-6 py-24 text-center">
        <h1 className="font-display text-5xl mb-4">YOUR CART IS EMPTY</h1>
        <Link to="/shop/shop-all" className="inline-block bg-[var(--gv-blue)] hover:bg-[var(--gv-blue-bright)] text-black px-8 py-4 font-bold uppercase tracking-widest text-sm transition-colors">Shop Gear</Link>
      </div>
    );

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
      <h1 className="font-display text-5xl mb-8">YOUR CART</h1>
      <div className="space-y-4">
        {items.map((it) => (
          <div key={it._id} data-testid="cart-item" className="flex gap-4 border border-white/10 bg-[#141518] p-4">
            <img src={it.front_image} alt={it.product_name} className="w-20 h-20 object-cover bg-black flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <h3 className="font-bold text-sm">{it.product_name}</h3>
              <p className="text-xs text-gray-400 mt-1">Size {it.size}{it.garment_color ? ` • ${it.garment_color}` : ""}{it.front_design_label ? ` • ${it.front_design_label}` : ""} • {BACK_OPTION_LABELS[it.back_option]}</p>
              {it.player_name && <p className="text-xs text-gray-400">{it.player_name} #{it.player_number} • {it.team}</p>}
              <div className="flex items-center gap-3 mt-2">
                <div className="flex items-center border border-white/10">
                  <button onClick={() => updateQty(it._id, it.quantity - 1)} className="p-1.5"><Minus className="w-3 h-3" /></button>
                  <span className="w-8 text-center text-sm font-bold">{it.quantity}</span>
                  <button onClick={() => updateQty(it._id, it.quantity + 1)} className="p-1.5"><Plus className="w-3 h-3" /></button>
                </div>
                <button onClick={() => removeItem(it._id)} data-testid="cart-remove-btn" className="text-gray-400 hover:text-red-400"><Trash2 className="w-4 h-4" /></button>
              </div>
            </div>
            <div className="text-right font-bold text-[var(--gv-blue-bright)]">${it.unit_price * it.quantity}</div>
          </div>
        ))}
      </div>

      <div className="mt-8 border border-white/10 bg-[#141518] p-6">
        <div className="flex justify-between text-sm mb-2"><span className="text-gray-400">Subtotal</span><span className="font-bold" data-testid="cart-subtotal">${subtotal.toFixed(2)}</span></div>
        <div className="flex justify-between text-sm mb-4 text-gray-400"><span>Includes 15% Gray Volleyball donation</span><span>${contribution}</span></div>
        <button onClick={() => navigate("/checkout")} data-testid="checkout-btn"
          className="w-full bg-[var(--gv-blue)] hover:bg-[var(--gv-blue-bright)] text-black font-bold uppercase tracking-widest text-sm py-4 transition-colors">
          Checkout — ${subtotal.toFixed(2)}
        </button>
      </div>
    </div>
  );
}
